// admin-pc 路由 (PR-22a-3 RFC-20260514-010 / PR-comm-6 加 withdraw-audit)
// 路由命名严格对应 prototype admin_pc.html#a-* 屏 ID

import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'm00-login',
    component: () => import('@/views/m00-login/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a01', requiresAuth: false },
  },
  // PR-DEMO-1-G-batch1 (2026-05-23): a02 运营概览 (登录后主屏)
  {
    path: '/dashboard',
    name: 'a02-dashboard',
    component: () => import('@/views/a02-dashboard/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a02', requiresAuth: true },
  },
  // RFC-20260617-002 (2026-06-17): a10 客户管理 (无主原型, PM 签布局; 增删改客户绑定的商户/搭配师)
  {
    path: '/customers',
    name: 'a10-customers',
    component: () => import('@/views/a10-customers/index.vue'),
    meta: { requiresAuth: true },
  },
  // F126 RFC-20260606-001 (2026-06-06): 商品审核 (pending_review → active/rejected)
  {
    path: '/product-audit',
    name: 'a-product-audit',
    component: () => import('@/views/a-product-audit/index.vue'),
    meta: { requiresAuth: true },
  },
  // RFC-20260527-001 阶段 5 前端 (2026-05-28): 品牌尺码表全局视图 (无主原型, PM 签布局; a06 已占用 a08 槽)
  {
    path: '/brand-sizing',
    name: 'a08-brand-sizing',
    component: () => import('@/views/a08-brand-sizing/index.vue'),
    meta: { requiresAuth: true },
  },
  // 2026-05-29 PM: 系统配置 (平台级业务规则配置, 与告警阈值分离避歧义)
  {
    path: '/system-config',
    name: 'a09-system-config',
    component: () => import('@/views/a09-system-config/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/narrative-config',
    name: 'a-narrative-config',
    component: () => import('@/views/a-narrative-config/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/customer-home-content',
    name: 'a-customer-home-content',
    component: () => import('@/views/a-home-content/index.vue'),
    meta: { prototypeRef: 'customer-public-home-abc.html?variant=D&style=editorial', requiresAuth: true },
  },
  {
    // RFC-20260618-002: 平台默认尺码表配置 (新 size_chart 系统)
    path: '/platform-size-charts',
    name: 'a08b-platform-size-chart',
    component: () => import('@/views/a08b-platform-size-chart/index.vue'),
    meta: { requiresAuth: true },
  },
  // PR-DEMO-1-G-batch2 (2026-05-23): a04 商家管理 + a05 搭配师管理
  {
    path: '/merchants',
    name: 'a04-merchants',
    component: () => import('@/views/a04-merchants/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a04', requiresAuth: true },
  },
  {
    path: '/stylists',
    name: 'a05-stylists',
    component: () => import('@/views/a05-stylists/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a05', requiresAuth: true },
  },
  // PR-DEMO-1-G-batch3 (2026-05-23): a03 标签流水线 + a06 工单仲裁
  {
    path: '/tagging',
    name: 'a03-tagging',
    component: () => import('@/views/a03-tagging/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a03', requiresAuth: true },
  },
  {
    path: '/appeals',
    name: 'a06-appeals',
    component: () => import('@/views/a06-appeals/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a06', requiresAuth: true },
  },
  // PR-DEMO-1-G-batch4 (2026-05-23): a03c 全部商品 + a07 合规审核
  {
    path: '/products-pool',
    name: 'a03c-products-pool',
    component: () => import('@/views/a03c-products-pool/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a03c', requiresAuth: true },
  },
  {
    path: '/compliance',
    name: 'a07-compliance',
    component: () => import('@/views/a07-compliance/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a07', requiresAuth: true },
  },
  // PR-DEMO-1-G-batch5 (2026-05-23): a02b 平台贡献 / a04b 单商家贡献 / a07b 告警阈值
  {
    path: '/platform-contribution',
    name: 'a02b-platform-contribution',
    component: () => import('@/views/a02b-platform-contribution/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a02b', requiresAuth: true },
  },
  {
    path: '/alert-thresholds',
    name: 'a07b-alert-thresholds',
    component: () => import('@/views/a07b-alert-thresholds/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a07b', requiresAuth: true },
  },
  // PR-DEMO-1-I-batch2 (2026-05-24): 平台审核中心独立屏 (PM 反馈 a04/a05 内嵌不显眼)
  {
    path: '/audit-center',
    name: 'a-audit-center',
    component: () => import('@/views/a-audit-center/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/authorization-audit',
    name: 'a-authorization-audit',
    component: () => import('@/views/a-authorization-audit/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a-authorization-audit', requiresAuth: true },
  },
  {
    path: '/withdraw-audit',
    name: 'a-withdraw-audit',
    component: () => import('@/views/a-withdraw-audit/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a-withdraw-audit', requiresAuth: true },
  },
  {
    path: '/review-audit',
    name: 'a-review-audit',
    component: () => import('@/views/a-review-audit/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a-review-audit', requiresAuth: true },
  },
  {
    path: '/appeal-audit',
    name: 'a-appeal-audit',
    component: () => import('@/views/a-appeal-audit/index.vue'),
    meta: { prototypeRef: 'admin_pc.html#a-appeal-audit', requiresAuth: true },
  },
];

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

// PR-DEMO-1-I-batch5-cont-fix2 (2026-05-24): beforeEach guard (token + requiresAuth)
//   防用户手动输 URL 进受保护页, 与 api.ts 401 兜底双保险
router.beforeEach((to, _from, next) => {
  const requiresAuth = to.meta?.requiresAuth === true;
  const hasToken = !!localStorage.getItem('auth:token');
  if (requiresAuth && !hasToken) {
    if (to.path !== '/login') {
      next({ path: '/login', replace: true });
      return;
    }
  }
  next();
});
